const transl={
    de:{
        resume:"Kurzbeschreibung",
        resumeText:"Starker Wille und Fokus halfen mir, Ziele zu erreichen, auch wenn die erforderlichen Fähigkeiten zunächst meine Schwächen waren. Beispiele sind meine Erfolge im Sport oder Verkauf, aber auch mein Englischniveau. Seit DCI habe ich die erste Vorstellung davon bekommen, wie schnell ich mein Wissen verbessern kann, wenn ich meiner wahren Leidenschaft nachgehe.",
        resumeText2:"Fokussierter und willensstarker Full Stack Web Entwickler mit Erfahrung in MongoDB, Express, React, und Node.js auf der Suche nach einer Tätigkeit als als Web/App-Developer, um meine  Fähigkeiten weiter zu vertiefen.",
        resumeText3:"Abteilungsleiter Anwendungsentwicklung mit Erfahrung in Projektplanung und Realisierung von Individualsoftware für Firmenkkunden, Vertriebsprofi und Programmierer.",
        skills:"Programmiersprachen",
        language:"Sprachkenntnisse",
        deutsch:"Deutsch",
        english:"Englisch",
        russisch:"Russisch",
        motherTounge:"Muttersprache",
        contact:"Kontakt",
        ausbildung:"Ausbildung",
        kurs:"Full Stack Web Entwicklung",
        kursText1:"Theoretische und praktische Grundlagenkenntnisse und Methodenkompetenzen der Web-Entwicklung",
        kursText2:"Vertieft in zahlreichen Einzel- und Gruppenprojekten",
        kursText3:"Teilnahme an Softskills-Training und Vertiefung der Englisch-Kenntnisse",
        blw:"Betriebswirtschaftslehre",
        aublildungBKM:"Ausbildung zum Bankkaufmann",
        beruflicheErfahrungen:"Berufliche Erfahrungen",
        selbststudium:"Selbst-Studium",
        lernprojekt:"Lern-Projekt",
        sos:"Erzieherausbildung Kinderheim",
        sosText:"Soziale Arbeit mit Kindern aus schwierigen familären Situationen",
        audibene:"Remote Kundenberater Hörgeräte",
        audibeneText:"Remote Beratung, Anamnese und Verkauf von Höhrhilfen",
        dittmer:"Filialleiter Vodafone Bad Bramstedt",
        dittmerText1:"Führung der Filiale während der Vergrößerung zum Business-Premium-Store",
        dittmerText2:"Aubildung neuer Mitarbeiter",
        dittmerIZ:"Verkaufsberater Vodafone",
        dittmerIZText:"Verkauf des Vodafone Produkportfolios",
        mediaMarkt:"Fachberater Neue Medien",
        mediaMarktText:"Verkauf Produkte Neue Medien",
        lbs:"Freiberuflicher Baufinanzierungsberater",
        lbsText:"Selbststädnige Finanzierungsberatung",
        lbsText2:"Bausparberatungen",
        spk:"Sparkassenbezirksleiter",
        spkText1:"Bausparberatungen",
        spkText2:"Schulungen der Mitarbeiter und Azubis",
        spkText3:"Erfolgreiche Produktplatzierung Wohnriester",
        spkText4:"Verdoppelung der Bauspar-Umsätze dreimal in Folge",
        vdf:"Studentische Aushilfe Vertriebsunterstützung",
        vdfText1:"Arbeitszeit-Studie Mehr Zeit am Kunden",
        vdfText2:"Entwicklung, Einführung und Pflege eine Tarifoptimierungs-Programms",
        haspa:"Jugend- und Privatkundenberater",
        paspaText:"Kundenberatung alle Bankprodukte und Kundengruppen",
        abteilungsleitung:"Abteilungsleitung Anwendungsentwicklung"
    },
    en:{
        resume:"Career objective",
        resumeText:"Strong will and focus hepled me to reach goals, even if the needed skill was initailly my weaknesses. Examples are my success in sports or sales, but also my English level. Since DCI I got the first idea of how fast I can improve my knowledge when I follow my real passion.",
        resumeText2:"Focused and strong-willed full stack web developer with experience in MongoDB, Express, React, and Node.js looking for a job as a web/app developer to expand my skills.",
        resumeText3:"Head of software development with experience in project planning and implementation of individual software for corporate customers, sales professional and programmer.",
        skills:"Skills",
        language:"Language skills",
        deutsch:"German",
        english:"English",
        russisch:"Russian",
        motherTounge:"Mothertounge",
        contact:"Contact",
        ausbildung:"Education",
        kurs:"Course Web-Development",
        kursText1:"Theoretical and practical basic knowledge and methodological skills of web development",
        kursText2:"Practised in numerous individual and group projects",
        kursText3:"Supplemented by soft skill training and Lingoda English course",
        blw:"Business Administration",
        aublildungBKM:"Apprenticeship as Banker",
        beruflicheErfahrungen:"Working experience",
        selbststudium:"Self study",
        lernprojekt:"lern project",
        sos:"Vocational training orphanage",
        sosText:"Social work with children from difficult family background",
        audibene:"Remote Sales advisor hearing aids",
        audibeneText:"Remote consultation, anamnesis and sale of hearing aids",
        dittmer:"Shopmanager Vodafone Bad Bramstedt",
        dittmerText1:"Management of the branch during the expansion to a business premium store",
        dittmerText2:"Training of new employees",
        dittmerIZ:"Sales advisor Vodafone",
        dittmerIZText:"Sale of the Vodafone product portfolio",
        mediaMarkt:"Specialist consultant for new media",
        mediaMarktText:"Sale products new media",
        lbs:"Freelance mortgage consultant",
        lbsText:"Independent financial advice",
        lbsText2:"Bauspar advising",
        spk:"Sparkassenbezirksleiter",
        spkText1:"Bauspar advising",
        spkText2:"Training for employees and trainees",
        spkText3:"Successful product placement Wohnriester",
        spkText4:"Doubling of Bauspar sales three times in a row",
        vdf:"Student assistant sales support",
        vdfText1:"Working time study More time with the customer",
        vdfText2:"Development, introduction and maintenance of a tariff optimization program",
        haspa:"Youth and private customer advisor",
        paspaText:"Customer advice for all banking products and customer groups",
        abteilungsleitung:"Head of Softwaredevelopment"
    },
    ke:{
        resume:"Career objective",
        resumeText:"Strong will and focus hepled me to reach goals, even if the needed skill was initailly my weaknesses. Examples are my success in sports or sales, but also my English level. Since DCI I got the first idea of how fast I can improve my knowledge when I follow my real passion.",
        resumeText2:"Focused and strong-willed full stack web developer with experience in MongoDB, Express, React, and Node.js looking for a job as a web/app developer to expand my skills.",
        resumeText3:"Head of software development with experience in project planning and implementation of individual software for corporate customers, sales professional and programmer.",
        skills:"Skills",
        language:"Language skills",
        deutsch:"German",
        english:"English",
        russisch:"Russian",
        motherTounge:"Mothertounge",
        contact:"Contact",
        ausbildung:"Education",
        kurs:"Course Web-Development",
        kursText1:"Theoretical and practical basic knowledge and methodological skills of web development",
        kursText2:"Practised in numerous individual and group projects",
        kursText3:"Supplemented by soft skill training and Lingoda English course",
        blw:"Business Administration",
        aublildungBKM:"Apprenticeship as Banker",
        beruflicheErfahrungen:"Working experience",
        selbststudium:"Self study",
        lernprojekt:"lern project",
        sos:"Vocational training orphanage",
        sosText:"Social work with children from difficult family background",
        audibene:"Remote Sales advisor hearing aids",
        audibeneText:"Remote consultation, anamnesis and sale of hearing aids",
        dittmer:"Shopmanager Vodafone Bad Bramstedt",
        dittmerText1:"Management of the branch during the expansion to a business premium store",
        dittmerText2:"Training of new employees",
        dittmerIZ:"Sales advisor Vodafone",
        dittmerIZText:"Sale of the Vodafone product portfolio",
        mediaMarkt:"Specialist consultant for new media",
        mediaMarktText:"Sale products new media",
        lbs:"Freelance mortgage consultant",
        lbsText:"Independent financial advice",
        lbsText2:"Bauspar advising",
        spk:"Sparkassenbezirksleiter",
        spkText1:"Bauspar advising",
        spkText2:"Training for employees and trainees",
        spkText3:"Successful product placement Wohnriester",
        spkText4:"Doubling of Bauspar sales three times in a row",
        vdf:"Student assistant sales support",
        vdfText1:"Working time study More time with the customer",
        vdfText2:"Development, introduction and maintenance of a tariff optimization program",
        haspa:"Youth and private customer advisor",
        paspaText:"Customer advice for all banking products and customer groups",
        abteilungsleitung:"Head of Softwaredevelopment"
    }
}

export default transl